import React, { useState, useEffect } from 'react';
import { FaSave, FaTimes } from 'react-icons/fa';
import { receitasAPI } from '../../services/api';
import { toast } from 'react-toastify';

const ReceitaModal = ({ receita, onClose, onSave }) => {
  const isEdit = !!receita;
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    nome: '',
    valor: '',
    data_receita: new Date().toISOString().split('T')[0],
    historico: ''
  });

  useEffect(() => {
    if (receita) {
      setFormData({
        nome: receita.nome,
        valor: receita.valor,
        data_receita: receita.data_receita.split('T')[0],
        historico: receita.historico || ''
      });
    }
  }, [receita]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.nome || !formData.valor || !formData.data_receita) {
      toast.error('Preencha todos os campos obrigatórios');
      return;
    }

    try {
      setLoading(true);
      
      if (isEdit) {
        await receitasAPI.update(receita.id, formData);
        toast.success('Receita atualizada com sucesso!');
      } else {
        await receitasAPI.create(formData);
        toast.success('Receita cadastrada com sucesso!');
      }
      
      onSave();
    } catch (error) {
      const message = error.response?.data?.message || 'Erro ao salvar receita';
      toast.error(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>{isEdit ? 'Editar Receita' : 'Nova Receita'}</h3>
          <button onClick={onClose} className="btn-close">
            <FaTimes />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="modal-form">
          <div className="form-group">
            <label htmlFor="nome">Nome da Receita *</label>
            <input
              type="text"
              id="nome"
              name="nome"
              value={formData.nome}
              onChange={handleChange}
              placeholder="Ex: Mensalidade, Evento, Doação..."
              required
              autoFocus
            />
          </div>

          <div className="form-row">
            <div className="form-group">
              <label htmlFor="valor">Valor (R$) *</label>
              <input
                type="number"
                id="valor"
                name="valor"
                value={formData.valor}
                onChange={handleChange}
                placeholder="0.00"
                step="0.01"
                min="0"
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="data">Data *</label>
              <input
                type="date"
                id="data_receita"
                name="data_receita"
                value={formData.data_receita}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="historico">Histórico / Observações</label>
            <textarea
              id="historico"
              name="historico"
              value={formData.historico}
              onChange={handleChange}
              placeholder="Informações adicionais sobre a receita..."
              rows="3"
            />
          </div>

          <div className="modal-actions">
            <button
              type="button"
              onClick={onClose}
              className="btn btn-secondary"
              disabled={loading}
            >
              <FaTimes /> Cancelar
            </button>
            <button
              type="submit"
              className="btn btn-primary"
              disabled={loading}
            >
              <FaSave /> {loading ? 'Salvando...' : 'Salvar'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ReceitaModal;
